import React, { useState } from 'react';
import { Subscribe } from 'unstated';

import { withErrorBoundary, Attribution } from '@confluence/error-boundary';
import { BannerStateContainer } from '@confluence/banners';
import { fg } from '@confluence/feature-gating';

import { BANNER_HEIGHT, Nav4PromptBanner } from './Nav4PromptBanner';

import { useIsProductAdmin } from '@confluence/current-user';

export const BANNER_NAME = './Nav4PromptGlobalBanner';
import { useIsNav4Enabled } from '@confluence/nav4-enabled';

/**
 * Conditions to show Nav4PromptBanner
 * - Nav3 users
 * - Site admins
 * - Do not show if banner has been previously dismissed
 */

const Nav4PromptBannerContainerComponent = () => {
	const { isProductAdmin, isAdminCheckLoading } = useIsProductAdmin();

	const [isDismissed, setDismissed] = useState<boolean>(false);
	const isNav4Enabled = useIsNav4Enabled();

	const shouldShowBanner = !isDismissed && !isNav4Enabled && isProductAdmin;

	if (!fg('confluence_nav4_admin_reminder_banner') || !shouldShowBanner || isAdminCheckLoading) {
		return null;
	}
	return (
		<Subscribe to={[BannerStateContainer]}>
			{(bannerState: BannerStateContainer) => {
				bannerState?.show(BANNER_NAME, BANNER_HEIGHT);
				const handleDismiss = () => {
					setDismissed(true);
					bannerState?.hide(BANNER_NAME);
				};
				return <Nav4PromptBanner onDismiss={handleDismiss} />;
			}}
		</Subscribe>
	);
};
export const Nav4PromptBannerContainer = withErrorBoundary({
	attribution: Attribution.DISCO,
})(Nav4PromptBannerContainerComponent);
